import { render, staticRenderFns } from "./AccommodationPlaces.vue?vue&type=template&id=50ccb6b4&scoped=true"
import script from "./AccommodationPlaces.vue?vue&type=script&lang=js"
export * from "./AccommodationPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ccb6b4",
  null
  
)

export default component.exports